module.exports = __webpack_public_path__ + "static/media/10.e66c92f5.jpeg";